import { createFileRoute } from '@tanstack/react-router';
import { FeatureFlag, RouteName, TextKey } from '@mews-commander/enums';
import { hasCurrentEnterpriseSsoAccessOnly, isCurrentEnterprisePortfolio } from '@mews-commander/legacy-entities';
import { Dashboard } from '@mews-commander/modules/src/modules/dashboard';
import { Redirect } from '@mews-commander/ui';
import { useCommanderSelector } from '@mews-commander/utils';
import { MewsTeam, RouteType } from '@mews/enums';
import { useEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { useFeatureFlag } from '@mews/framework';
import { AuditStatusFilter } from '@mews-commander/onboarding';

const DashboardWithRedirect = () => {
    const isPortfolio = useCommanderSelector(isCurrentEnterprisePortfolio);
    const hasSsoAccessOnly = useCommanderSelector(hasCurrentEnterpriseSsoAccessOnly);
    const { currentEnterpriseId } = Route.useParams();
    const enterprise = useEnterprise(currentEnterpriseId);
    const isOnboardingCompletionCheckEnabled = useFeatureFlag(FeatureFlag.onboardingCompletionCheckEnabled);

    if (isPortfolio) {
        if (hasSsoAccessOnly) {
            return <Redirect to="/$currentEnterpriseId/UserGroups/Index" params={{ currentEnterpriseId }} />;
        }

        return (
            <Redirect to="/$currentEnterpriseId/EnterpriseRelationshipReport/Index" params={{ currentEnterpriseId }} />
        );
    }

    if (!enterprise.isOnboardingFinished && isOnboardingCompletionCheckEnabled) {
        return (
            <Redirect
                to="/$currentEnterpriseId/Settings/GoLiveAudits/Setup"
                params={{ currentEnterpriseId }}
                search={{ auditStatus: AuditStatusFilter.All }}
            />
        );
    }

    return <Dashboard />;
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Dashboard/Index/')({
    component: DashboardWithRedirect,
    staticData: {
        routeName: RouteName.DashboardIndex,
        title: TextKey.Dashboard,
        owner: MewsTeam.Accounts,
        type: RouteType.Frontend,
    },
});
